import axios from "axios";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Editing,
  Form,
  LoadPanel,
  Popup,
  Scrolling,
  SearchPanel,
  Selection,
  Texts,
} from "devextreme-react/data-grid";
import { Label, RequiredRule, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

export default function DivisionInformation() {
  const [dataSource, setDataSource] = useState(null);
  const [divDataSource, setDivDataSource] = useState(null);

  const userInfo = useSelector((state) => state.userInfo);

  const dataGridRef = useRef(null);

  useEffect(async () => {
    setDataSource(
      new CustomStore({
        key: "SEQ",
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/personnelInfo/divInfo/${userInfo.employeeNo}`
          );

          return result.data;
        },
        insert: async (values) => {
          values.mainDiv = values.mainDiv ? "1" : "0";

          await axios.post(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/personnelInfo/divInfo/${userInfo.employeeNo}`,
            values
          );
        },
        update: async (key, values) => {
          values.mainDiv = values.mainDiv ? "1" : "0";

          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/personnelInfo/divInfo/${userInfo.employeeNo}/${key}`,
            values
          );
        },
        remove: async (key) => {
          await axios.delete(
            `${process.env.REACT_APP_BECCO_API_URL}/api/persRcrd/personnelInfo/divInfo/${userInfo.employeeNo}/${key}`
          );
        },
        errorHandler: (error) => {
          if (error.message == "Request failed with status code 409") {
            error.message = `The department information is duplicated.`;
          } else if (error.message == "Request failed with status code 406") {
            error.message = `The main department is already set up.`;
          }
        },
      })
    );

    const result = await axios.get(
      `${process.env.REACT_APP_BECCO_API_URL}/api/employee/div`
    );

    setDivDataSource(result.data);
  }, []);

  const onInitNewRow = (e) => {
    const key = dataGridRef.current.instance.getKeyByRowIndex(0);

    if (key) {
      e.component.selectRows(key, true);
      e.data = dataGridRef.current.instance.getSelectedRowsData()[0];
    } else {
      e.data.mainDiv = false;
    }
  };

  const onEditingStart = (e) => {
    e.data.mainDiv = e.data.mainDiv == "1" ? true : false;
  };

  const calculateDisplayValue = (data) => {
    return `${data.mainDiv == true ? "V" : ``}`;
  };

  return (
    <DataGrid
      id="divisionInfoGrid"
      ref={dataGridRef}
      dataSource={dataSource}
      keyExpr="SEQ"
      rowAlternationEnabled={true}
      showBorders={true}
      showColumnLines={true}
      allowColumnResizing={true}
      columnAutoWidth={true}
      wordWrapEnabled={true}
      allowColumnReordering={true}
      style={{
        maxHeight: "calc(100vh - 180px)",
        marginLeft: "10px",
        marginRight: "10px",
      }}
      hoverStateEnabled={true}
      showColumnHeaders={true}
      onInitNewRow={onInitNewRow}
      onEditingStart={onEditingStart}
    >
      <LoadPanel enabled={true} />

      <SearchPanel visible={true} />

      <Scrolling mode={"virtual"} showScrollbar={"always"} />

      <Selection mode="single" />

      <Editing
        mode={"popup"}
        allowAdding={true}
        allowUpdating={true}
        allowDeleting={true}
      >
        <Texts
          confirmDeleteTitle="Delete the Division Info."
          confirmDeleteMessage={
            "Are you sure you want to delete this divition info?"
          }
        />
        <Popup
          title={"DIVISION INFO."}
          showTitle={true}
          height={"auto"}
          width={1200}
        />
        <Form
          labelMode={"outside"}
          showColonAfterLabel={false}
          labelLocation="top"
          minColWidth={300}
          colCount={2}
          colCountByScreen={{ sm: 2, md: 4 }}
          screenByWidth={(width) => {
            return width < 720 ? "sm" : "md";
          }}
          validationGroup="divisionInfo"
          height={"100%"}
        >
          <SimpleItem
            dataField={"apptDate"}
            editorType="dxDateBox"
            editorOptions={{
              type: "date",
              displayFormat: "yyyy-MM-dd",
              dateSerializationFormat: "yyyy-MM-dd",
              showClearButton: true,
            }}
          >
            {/* <Label text={"발령일"} /> */}
            <Label text={"Appointment Date"} />
            <RequiredRule message={"* Appointment date is required."} />
          </SimpleItem>
          <SimpleItem
            dataField={"div"}
            editorType="dxSelectBox"
            editorOptions={{
              showClearButton: true,
              dataSource: divDataSource,
              valueExpr: "div",
              displayExpr: "name",
            }}
            colSpan={2}
          >
            {/* <Label text={"부서"} /> */}
            <Label text={"Department"} />
            {/* <RequiredRule message={"* 부서를 입력해주세요."} /> */}
            <RequiredRule message={"* Department is required."} />
          </SimpleItem>
          <SimpleItem
            dataField={"mainDiv"}
            editorType="dxCheckBox"
            editorOptions={{
              // text: "주부서",
              text: "Main Department",
            }}
            cssClass={"checkbox"}
          >
            <Label visible={false} />
          </SimpleItem>
        </Form>
      </Editing>

      <Column
        dataField="apptDate"
        // caption="발령일"
        caption="Appointment Date"
        dataType="date"
        format="yyyy-MM-dd"
        editorOptions={{
          dateSerializationFormat: "yyyy-MM-dd",
        }}
        width={150}
        alignment={"center"}
      ></Column>
      <Column
        dataField={"mainDiv"}
        // caption="주부서"
        caption="Main"
        // setCellValue={setCellValue}
        calculateDisplayValue={calculateDisplayValue}
        width={100}
        alignment={"center"}
      />
      <Column dataField={"div"} caption="" width={50} alignment={"center"} />
      {/* <Column dataField={"name"} caption="부서" /> */}
      <Column dataField={"name"} caption="Department" />
    </DataGrid>
  );
}
